import {onFind} from "@elements/init-modules-in-scope";
import {on} from '@elements/dom-utils';

export function init () {
    onFind('.js-reload-select', (select) => {
        on('change', () => {
            if (select.options[select.selectedIndex].getAttribute('data-href')) {
                window.location.href = select.options[select.selectedIndex].getAttribute('data-href');
            }
            // select.options[select.selectedIndex]
        }, select);
    });
}